import {
    Button,
    Calendar,
    FormControl,
    FormField,
    FormItem,
    FormMessage,
    Input,
    Label,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@repo/shadcn';
import { CalendarIcon } from 'lucide-react';
import { useState } from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';

function formatDate(date: Date | undefined) {
    if (!date) {
        return '';
    }

    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'numeric',
        year: 'numeric',
    });
}

function isValidDate(date: Date | undefined) {
    if (!date) {
        return false;
    }

    return !isNaN(date.getTime());
}

type DateInputFieldProps<T extends FieldValues> = {
    name: Path<T>;
    label?: string;
};

export const DateInputField = <T extends FieldValues>({
    name,
    label = undefined,
}: DateInputFieldProps<T>) => {
    const [open, setOpen] = useState(false);
    const [date, setDate] = useState<Date | undefined>(new Date());
    const [month, setMonth] = useState<Date | undefined>(date);
    // const [value, setValue] = useState(formatDate(date));

    const { control } = useFormContext<T>();

    return (
        <FormField
            name={name}
            control={control}
            render={({ field }) => (
                <FormItem>
                    <FormControl>
                        <div className="w-full max-w-xs space-y-2">
                            {label && (
                                <Label htmlFor="date" className="px-1">
                                    Expiration Date
                                </Label>
                            )}
                            <div className="relative flex gap-2">
                                <Input
                                    // id="date"
                                    {...field}
                                    value={
                                        field.value
                                            ? formatDate(new Date(field.value))
                                            : ''
                                    }
                                    placeholder="20/5/2026"
                                    className="bg-background pr-10"
                                    onChange={(e) => {
                                        const date = new Date(e.target.value);

                                        // setValue(e.target.value);

                                        if (isValidDate(date)) {
                                            setDate(date);
                                            setMonth(date);
                                            field.onChange(date);
                                            // setFormValue(name, date as any);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setOpen(true);
                                        }
                                    }}
                                />
                                <Popover open={open} onOpenChange={setOpen}>
                                    <PopoverTrigger asChild>
                                        <Button
                                            id="date-picker"
                                            variant="outline"
                                            className="absolute right-2 top-1/2 size-6 -translate-y-1/2 p-0"
                                        >
                                            <CalendarIcon className="size-3 text-black" />
                                            <span className="sr-only">
                                                Pick a date
                                            </span>
                                        </Button>
                                    </PopoverTrigger>
                                    <PopoverContent
                                        className="w-auto overflow-hidden p-0"
                                        align="end"
                                        alignOffset={-8}
                                        sideOffset={10}
                                    >
                                        <Calendar
                                            mode="single"
                                            selected={field.value}
                                            month={month}
                                            onMonthChange={setMonth}
                                            onSelect={(date) => {
                                                setDate(date);
                                                // setValue(formatDate(date));
                                                // setFormValue(
                                                //     name,
                                                //     date?.toISOString() as any,
                                                // );
                                                field.onChange(date);
                                                setOpen(false);
                                            }}
                                        />
                                    </PopoverContent>
                                </Popover>
                            </div>
                        </div>
                    </FormControl>
                    <FormMessage className="line-clamp-1 text-xs" />
                </FormItem>
            )}
        />
    );
};

DateInputField.displayName = 'DateInputField';
